module.exports = __webpack_public_path__ + "static/media/Music.287c0d36.png";